// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"41":"f21701cb2f32d933","973":"fe728d9e83cc1624"}[chunkId] + ".css";
};